import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { UsersImportService } from '@app/modules/admin/users-import-v2/users-import-v2-service';
import { UsersImportV2Component } from '@app/modules/admin/users-import-v2/users-import-v2.component';
import { onReloadConfirmationData } from '@app/modules/admin/users-import-v2/users-import.const';
import { FuseConfirmationService } from '@fuse/services/confirmation';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean;
}

@Injectable({
    providedIn: 'root',
})
export class UserImportV2CanDeactivateGuard
    implements CanDeactivate<UsersImportV2Component>
{
    constructor(private _fuseConfirmationService: FuseConfirmationService) { }

    canDeactivate(
        component: UsersImportV2Component
    ): boolean | Promise<boolean> {
        if (UsersImportService.isImportInProgress === false) return true;
        const dialogRef = this._fuseConfirmationService.open(onReloadConfirmationData);
        return new Promise((res) => {
            dialogRef.afterClosed().subscribe((val: 'confirmed' | 'cancelled') => {
                const timeOut = setTimeout(() => {
                    return false;
                }, 10_000);
                if (val === 'confirmed') {
                    clearTimeout(timeOut);
                    res(true);

                } else if (val === 'cancelled') {
                    clearTimeout(timeOut);
                    res(false);
                }
            });
        });
    }
}
